import render from 'ui-react-render';
import Error404 from './components/404';
import 'ui-header';
import 'ui-footer';
import '@shared_modules/propulsion/core/styles.scss';

render(Error404);

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/pages/404/404.scss');